var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    fill: "white",
    stroke: "#D1D9E0",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 22.8292C18.4319 22.8292 18.4465 22.8292 18.4506 22.8292C18.8785 22.8292 19.2829 22.6606 19.5892 22.3542L21.7871 20.1563C22.104 19.8395 22.104 19.3273 21.7871 19.0104L18.5454 15.7686C18.2285 15.4517 17.7163 15.4517 17.3994 15.7686L16.1076 17.0605C15.5087 16.8822 14.3911 16.4769 13.6828 15.7686C12.9744 15.0603 12.5692 13.9427 12.3909 13.3438L13.6828 12.052C13.9996 11.7351 13.9996 11.2229 13.6828 10.906L10.441 7.66425C10.1371 7.36033 9.59897 7.36033 9.29505 7.66425L7.09796 9.86216C6.78999 10.1701 6.61656 10.5932 6.62304 11.0251C6.64168 12.1792 6.94721 16.1876 10.1063 19.3467C13.2654 22.5058 17.2738 22.8105 18.4279 22.8292ZM9.86884 9.38319L11.9646 11.479L10.9167 12.5269C10.723 12.7198 10.6404 12.9985 10.6971 13.266C10.7166 13.3592 11.1923 15.5693 12.5376 16.9146C13.8829 18.2599 16.093 18.7356 16.1862 18.7551C16.4561 18.8118 16.7324 18.7292 16.9253 18.5355L17.9732 17.4876L20.069 19.5834L18.4433 21.2083C17.4318 21.1913 13.9713 20.9198 11.2523 18.1999C8.52433 15.472 8.26012 11.9993 8.24391 11.0081L9.86884 9.38319ZM21.2101 13.9143H22.831C22.831 9.7568 19.6922 6.62122 15.5289 6.62122V8.24209C18.8209 8.24209 21.2101 10.6272 21.2101 13.9143Z",
    fill: "#A33635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5364 11.4837C17.2407 11.4837 17.9677 12.2106 17.9677 13.915H19.5886C19.5886 11.3013 18.15 9.86279 15.5364 9.86279V11.4837V11.4837Z",
    fill: "#A33635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertPc);
export default __webpack_public_path__ + "static/media/ExpertPC.3f87c8a263b665a0c77f666fb07d142c.svg";
export { ForwardRef as ReactComponent };